module.exports = {"id":"192445","name":"Daniel Ginczek","rating":"76","photo":"./data/images/photos/3/192445.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielGinczek0.json
// module id = 932
// module chunks = 0